import {Injectable, TemplateRef} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable()
export class TooltipService {
    private showSubject$ = new Subject<{text: string | TemplateRef<any>; rect: DOMRect; context: any}>();
    private hideSubject$ = new Subject<void>();
    show$ = this.showSubject$.asObservable();
    hide$ = this.hideSubject$.asObservable();

    showTooltip(text: string | TemplateRef<any>, rect: DOMRect, context: any = null) {
        this.showSubject$.next({
            text,
            rect,
            context,
        });
    }

    hideTooltip() {
        this.hideSubject$.next();
    }
}
